module.exports = __webpack_public_path__ + "img/edMat.2590ad58.jpg";